import { baseContentRoutes, baseFooterData, defaultConfig, getApi } from '../../base/defaultConfig';

export const config = {
  ...defaultConfig,
  'global.siteUrl': 'https://thesuntravel.breakfreeholidays.co.uk',
  'global.brandName': 'Breakfree Holidays',
  'google.gtm': 'GTM-K92HRPS',
  'socialMedia.telephone': 'tel:03332201901',
  'user.optin.emailOpt': true,
  'user.optin.smsOpt': false,
  'user.optin.thirdOpt': true,
  'logo.width': '258px',
  siteCode: 'SN',
  'campaign.referer': 'suntravel',
  'google.reactGA': 'G-QGMSFEYSSE',
};

export const contentRoutes = [
  ...baseContentRoutes,
  { path: '/about-us', pageId: '1512' },
  { path: '/offers', pageId: '1824' },
  { path: '/hotels', pageId: '1828' },
];

baseFooterData.holidayType.links[5].path = '/european-holiday-parks';
export const footerLinks = baseFooterData;

export const urls = getApi('api');
